import ProjectData from '@/data/ProjectData.ts'

export default [
    new ProjectData("project-1", "Rogue Candy", "img/projects/RogueCandy-Full_3.jpg", 
    `
    <div class="paragraph">
     <strong>Rogue Candy</strong> is a 3D Action Rogue-Like FPS in a whimsical candy world!
     Strengthen your character, explore randomized candy biomes, and engage in physics-based combat against wobbly candy creatures.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/HQRXQ33Hfco" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
        <a href="https://nikode.itch.io/rogue-candy-demo-prototype" rel="noopener noreferrer" target="_blank"><img style="max-width:150px; padding-right:10px" src="img/projects/badge-color.png" alt="Play on Itch" /></a>
    
        <a href="https://store.steampowered.com/app/3548650/Rogue_Candy/" rel="noopener noreferrer" target="_blank"><img style="max-width:150px; padding-left:10px" src="img/projects/SteamLogo_Dark.png" alt="Play on Itch" /></a>
    </div>

           <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/rc1.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rc2.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rc3.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/rc4.jpg" alt="Screenshot">
        </div>

        <div class="paragraph center">
        <strong>Gameplay Features:</strong>
        </div>

        <div class="row align-items-center page-section-quarter-top paragraph">
        <div class="col-lg-6 order-lg-1">
          <div class="p-3">
            <ul class="bigger-text custom-font">
              <li>
                Strengthen your character by finding perk stations and upgrade shops scattered throughout the world, enhancing your abilities and firepower with synergy builds.
              </li>
              <li>
                Each run offers a unique experience with a randomized open-world map build with different handmade candy-themed biomes, with future updates introducing chocolate, waffle, and licorice.
              </li>
                <li>
                Defeat a variety of sugary enemies and bosses using physics-based combat that adds chaos and fun to every fight!
              </li>
            </ul>
          </div>
        </div>
      </div>

                <div class="paragraph center">
        <strong>About:</strong>
        </div>

        <div class="paragraph">
        Welcome to the sweet and chaotic world of <strong>Rogue Candy</strong>! A 3D Action Rogue-Like FPS where the landscape is crafted from sugary treats and the inhabitants are living, 
        jiggly candy creatures.
        <br><br>
        Your goal is to reach the <strong>giant candy castle</strong> and defeat the residing main boss, but be wary... The further you proceed, the more dangerous the world becomes, so make sure to explore the candy-filled environments and gather loot from defeated candy creatures to upgrade your character and match your foes!
        <br><br>
        With pre-designed level chunks and random seed-based world generation, no two runs are the same, ensuring endless replayability with a beautiful candy world aesthetic. Get ready to experience a sugar rush of excitement and chaos!
        </div>

            <div class="paragraph center">
        <a href="https://nikode.itch.io/rogue-candy-demo-prototype" rel="noopener noreferrer" target="_blank"><img style="max-width:150px; padding-right:10px" src="img/projects/badge-color.png" alt="Play on Itch" /></a>
    
        <a href="https://store.steampowered.com/app/3548650/Rogue_Candy/" rel="noopener noreferrer" target="_blank"><img style="max-width:150px; padding-left:10px" src="img/projects/SteamLogo_Dark.png" alt="Play on Itch" /></a>
    </div>

    `, "#d63cb0", true, true),
    new ProjectData("project-2", "Snowmen", "img/projects/snowmen-2.jpg", `
    <div class="paragraph">
        <strong>Snowmen</strong> is a fairy tale like short horror game where you must escape a hellish snowy environment by collecting unusual ingredients and avoiding otherworldly dangers!
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/VXIoyi9letU" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">    
        <a href="https://store.steampowered.com/app/2325770/Snowmen/" rel="noopener noreferrer" target="_blank"><img style="max-width:150px" src="img/projects/SteamLogo_Dark.png" alt="Play on Itch" /></a>
    </div>

           <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/C&R-Gore-2-Epic-2.gif" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/Note-2-Epic.gif" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/s1.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/s2.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/s3.jpg" alt="Screenshot">
        </div>

        <div class="paragraph center">
        <strong>Gameplay:</strong>
        </div>

<div class="row align-items-center page-section-quarter-top paragraph">
        <div class="col-lg-6 order-lg-1">
          <div class="p-3">
            <ul class="bigger-text custom-font">
              <li>
                Keep <strong>MOVING</strong>, as time is short and <strong>DANGER</strong> is close by!
              </li>
              <li>
                <strong>COLLECT</strong>, <strong>COLLECT</strong>, <strong>COLLECT</strong> and... <strong>RUN</strong>!!!
              </li>
                <li>
                <strong>EXPLORE</strong> a seemingly infinite realm you are trapped in!
              </li>
              <li>
                <strong>SEARCH</strong> and navigate with the help of <strong>LANDMARKS</strong> and <strong>AUDIO</strong> cues!
              </li>
              <li>
                <strong>INTERACT</strong> with the environment and its strange, yet familiar looking inhabitants to retrieve useful information!
              </li>
              <li>
                <strong>CHOICES</strong> matter, so be wary about your actions!
              </li>
            </ul>
          </div>
        </div>
      </div>

        <div class="paragraph center">
        <strong>Story:</strong>
        </div>

        <div class="paragraph">
A fairy tale like short horror game where you get kicked out of your HOME for being very naughty!
<br><br>
You prepare for a journey to start a new life after the unfair and irresponsible treatment you witnessed!
<br>
But things don't turn out as expected, as it is usually the case in life...
<br><br>
This is different though... But it surely can't be bewitched, right?
<br>
Especially not at this holy and blessed time full of love where you spend time with your close ones!!
<br><br>
...Oh wait.
<br><br>
That time is already behind you and so is your PATH ahead, as you are already lost.
<br>
You are not alone though, for better or for worse.
<br><br>
...Probably worse.
<br><br>
Even the good old stories about the kind gift bringer seem to be all lies and can't be trusted either.
<br>
So who can you trust in this cold nightmarish realm?
<br><br>
The only thing left is to keep MOVING forward and finding a way back.
<br>
Hope just can't be all lost, right?! 
        </div>

            <div class="paragraph center">    
        <a href="https://store.steampowered.com/app/2325770/Snowmen/" rel="noopener noreferrer" target="_blank"><img style="max-width:150px" src="img/projects/SteamLogo_Dark.png" alt="Play on Itch" /></a>
    </div>

    `, "#5a78af", true, false),
    new ProjectData("project-3", "Sunder Islands", "img/projects/wooden_platforms.jpg", `
    <div class="paragraph">
        You are sent to an alien planet with the mission to extract enormous chunks of resources to your mothership, waiting in outer space. This is not an easy task though, due to the bizarre geographical structure or rather missing structure and hostile environment.
        <br>
        <br>
        The only solid objects inhabited by this gas planet are floating islands, which makes the crossing tricky without bridges and flying vehicles. For that reason, you have a helping tool that can build physically based structures like platforms and bridges to get you to higher terrain or far away ground.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/f9Yigu7uKb0" frameborder="0" allowfullscreen></iframe>
        <iframe class="youtube" src="https://www.youtube.com/embed/A4OoxtzK7HM" frameborder="0" allowfullscreen></iframe>
        <iframe class="youtube" src="https://www.youtube.com/embed/zuOUxkFoUQY" frameborder="0" allowfullscreen></iframe>
        <iframe class="youtube" src="https://www.youtube.com/embed/GOGmZu5obWs" frameborder="0" allowfullscreen></iframe>
    </div>

       <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/demo-island-grass-outerview-iwocon-logo.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/silver_platforms_structure.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/wooden_structure.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/foggy.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/demo-island-grass-treeview.jpg" alt="Screenshot">
        <img class="pc-screenshot" src="img/projects/holo-ui.jpg" alt="Screenshot">
        </div>

        <div class="paragraph center">
        <strong>Main Features:</strong>
    </div>

<div class="row align-items-center page-section-quarter-top paragraph">
        <div class="col-lg-6 order-lg-1">
          <div class="p-3">
            <ul class="bigger-text custom-font">
              <li>
                Structure building system
                <ul>
                  <li>
                    Crafting
                  </li>
                  <li>
                    Physically based
                  </li>
                  <li>
                    Realtime placing
                  </li>
                </ul>
              </li>
              <li>
                Resource gathering
              </li>
              <li>
                Tool upgrades
              </li>

              <li>
                Exploration
                <ul>
                  <li>
                    First person experience
                  </li>
                  <li>
                    Floating islands
                  </li>
                  <li>
                    Alien monuments
                  </li>
                  <li>
                    Alien vegetation and animals
                  </li>
                </ul>
              </li>
              <li>
                Volumetric clouds
              </li>
              <li>
                Weather events
                <ul>
                  <li>
                    Thunder storm
                  </li>
                  <li>
                    Wind storm
                  </li>
                  <li>
                    Fog
                  </li>
                </ul>
              </li>
              <li>
                Day and night cycle
              </li>
            </ul>
          </div>
        </div>
      </div>

    <div class="paragraph center">    
        This project is on hold! But you can check out the website <a href="https://sunder-islands.com/" rel="noopener noreferrer" target="_blank">here</a>.
    </div>
    `, "#312d1a", false, true),
];